/* Pickup dates use the bakery's local calendar, including mixed-cart restrictions. */
const WuolletPickupRules = {
  dates(raw) {
    return String(raw || '').split(',').map(value => value.trim().replace(/^['"]|['"]$/g, '')).filter(Boolean);
  },
  format(date) {
    return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
  },
  parse(value) {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || '');
    if (!match) return null;
    const date = new Date(Number(match[3]), Number(match[1]) - 1, Number(match[2]));
    return this.format(date) === value ? date : null;
  },
  localNow(now, timeZone) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(now).map(part => [part.type, part.value]));
    return { date: new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day)), hour: Number(parts.hour) };
  },
  minimum(types, now, timeZone) {
    const local = this.localNow(now, timeZone);
    const days = types.some(type => ['1', '2', '3'].includes(type)) ? 2 : 1;
    local.date.setDate(local.date.getDate() + days + (local.hour >= 8 ? 1 : 0));
    return local.date;
  },
  allowed(date, config, now = new Date()) {
    if (!date || date < this.minimum(config.types, now, config.timeZone)) return false;
    const value = this.format(date);
    return !config.excluded.includes(value)
      && (!config.types.includes('1') || !config.first.length || config.first.includes(value))
      && (!config.types.includes('2') || !config.second.length || config.second.includes(value));
  }
};

class WuolletPickup extends HTMLElement {
  connectedCallback() {
    this.config = {
      types: WuolletPickupRules.dates(this.dataset.types),
      first: WuolletPickupRules.dates(this.dataset.firstDates),
      second: WuolletPickupRules.dates(this.dataset.secondDates),
      excluded: WuolletPickupRules.dates(this.dataset.excludedDates),
      timeZone: this.dataset.timeZone
    };
    this.required = this.config.types.some(type => ['1', '2', '3', '4'].includes(type));
    this.hidden = !this.required;
    this.input = this.querySelector('[data-pickup-date]');
    this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
    this.status = this.querySelector('[data-pickup-status]');
    this.onSubmit = event => {
      if (event.target.id !== 'cart') return;
      this.refresh();
      if (!this.valid) {
        event.preventDefault();
        this.status.textContent = this.dataset.requiredMessage;
        this.input.focus();
        return;
      }
      if (this.required) {
        const note = document.getElementById('Cart-note');
        const time = this.radios.find(radio => radio.checked)?.value;
        if (note) {
          const existing = note.value.replace(/^Date: \d{2}\/\d{2}\/\d{4} - Time: [^\n]*(?:\n\n)?/, '');
          note.value = `Date: ${this.input.value} - Time: ${time}${existing ? '\n\n' + existing : ''}`;
        }
      }
    };
    document.addEventListener('submit', this.onSubmit);
    if (this.required && window.jQuery?.fn.datepicker) {
      window.jQuery(this.input).datepicker({
        dateFormat: 'mm/dd/yy',
        minDate: WuolletPickupRules.minimum(this.config.types, new Date(), this.config.timeZone),
        beforeShow: () => ({ minDate: WuolletPickupRules.minimum(this.config.types, new Date(), this.config.timeZone) }),
        beforeShowDay: date => [WuolletPickupRules.allowed(date, this.config)],
        onSelect: () => {
          this.radios.forEach(radio => { radio.checked = false; });
          this.refresh();
        }
      });
    }
    this.addEventListener('change', () => this.refresh());
    this.refresh();
  }

  disconnectedCallback() {
    document.removeEventListener('submit', this.onSubmit);
    if (window.jQuery?.fn.datepicker && this.input?.classList.contains('hasDatepicker')) {
      window.jQuery(this.input).datepicker('destroy');
    }
  }

  refresh() {
    const date = WuolletPickupRules.parse(this.input.value);
    const allowed = date && WuolletPickupRules.allowed(date, this.config);
    if (!allowed) this.input.value = '';
    this.radios.forEach(radio => {
      const visible = Boolean(allowed) && (radio.dataset.day === 'sunday') === (date?.getDay() === 0);
      radio.disabled = !visible;
      radio.closest('[data-pickup-slot]').hidden = !visible;
      if (!visible) radio.checked = false;
    });
    this.input.disabled = !this.required;
    this.valid = this.dataset.empty !== 'true' && (!this.required || Boolean(allowed && this.radios.some(radio => radio.checked && !radio.disabled)));
    const button = document.getElementById('checkout');
    if (button) button.disabled = !this.valid;
    this.status.textContent = '';
    const dates = [
      this.config.types.includes('1') ? this.config.first : [],
      this.config.types.includes('2') ? this.config.second : []
    ].find(list => list.length);
    if (this.required && dates && !dates.some(value => WuolletPickupRules.allowed(WuolletPickupRules.parse(value), this.config))) {
      this.status.textContent = this.dataset.unavailableMessage;
    }
  }
}
customElements.define('wuollet-pickup', WuolletPickup);
